export const configuracionColumnasOperacionesCanceladas = [
    {
        name: "institucion",
        field: "institucion",
        label: "Institución",
        align: "left",
    },
    {
        name: "numero_operaciones",
        field: "numero_operaciones",
        label: "Número de operaciones",
        align: "left",
    },
    {
        name: "valor_original",
        field: "valor_original",
        label: "Valor original",
        align: "left",
    },
    {
        name: "forma_cancelacion",
        field: "forma_cancelacion",
        label: "Forma de cancelación",
        align: "left",
    },
    {
        name: "fecha_cancelacion",
        field: "fecha_cancelacion",
        label: "Fecha de cancelación",
        align: "left",
    },
];
